"use client";
import { styled } from "@mui/material/styles";
import { visuallyHidden } from "@mui/utils";
import { SpaceXxs, FontSize200 } from "@nxt-costco-com/forge-design-tokens";
const StyledPriceSpan = styled("span")(
  ({ isFrench }) => ({
    fontSize: FontSize200,
    lineHeight: 1,
    marginLeft: isFrench ? SpaceXxs : 0,
    marginRight: "1px",
    position: "relative",
    top: "-0.5em"
  })
);
const StyledPriceSpanDefault = styled("span")(() => ({
  fontSize: FontSize200,
  lineHeight: 1,
  verticalAlign: "super"
}));
const StyledHiddenSpan = styled("span")(() => ({ ...visuallyHidden }));
export {
  StyledHiddenSpan,
  StyledPriceSpan,
  StyledPriceSpanDefault
};
